import { createFileRoute } from "@tanstack/react-router";

import OrgAdminAcceptInvite from "/src/routes/orgAdmin/AcceptInvite";

export const Route = createFileRoute("/acceptInvite")({
  component: OrgAdminAcceptInvite,
});
